<form [formGroup]="getChangePasswordForm()" class="form-container ng" novalidate
		(ngSubmit)="save(getChangePasswordForm().value)">
  <h1>{{'Change password' | translate}}</h1>

  <div class="form-group" fxLayout fxLayout.xs="column" fxLayoutAlign="space-between center">
		<label class="control-label" fxFlex="45" for="oldPassword">
			{{'Old password' | translate}} *
		</label>
		<div class="input-container" fxFlex="55" fxLayout="column">
			<input
				formControlName="oldPassword"
				type="password"
				class="form-control"
				id="oldPassword" name="oldPassword">
			<div fxLayout="column" class="feedback-wrapper"
					*ngIf="getChangePasswordForm().controls['oldPassword'].errors && (getChangePasswordForm().controls['oldPassword'].dirty || getChangePasswordForm().controls['oldPassword'].touched)">
				<small [hidden]="!getChangePasswordForm().controls['oldPassword'].errors.required" class="feedback">
					{{'Required' | translate}}.
				</small>
			</div>
		</div>
  </div>

	<div class="form-group" fxLayout fxLayout.xs="column" fxLayoutAlign="space-between center">
		<label for="password" class="control-label" fxFlex="45">
			{{'New password' | translate}} *
		</label>
		<div class="input-container" fxFlex="55" fxLayout="column">
			<input
				formControlName="password"
				type="password"
				class="form-control"
				id="password" name="password">
			<div fxLayout="column" class="feedback-wrapper"
					*ngIf="getChangePasswordForm().controls['password'].errors && (getChangePasswordForm().controls['password'].dirty || getChangePasswordForm().controls['password'].touched)">
				<small [hidden]="!getChangePasswordForm().controls['password'].errors.required" class="feedback">
					{{'Required' | translate}}.
				</small>
				<small [hidden]="!getChangePasswordForm().controls['password'].errors.pattern" class="feedback">
					{{'Must contain at least 1 uppercase [A-Z], 1 lowercase [a-z] and 1 character[0-9]' | translate}}.
				</small>
				<small [hidden]="!getChangePasswordForm().controls['password'].errors.minlength" class="feedback">
					{{'Should be at least 8 characters long' | translate}}.
				</small>
			</div>
    </div>
  </div>

	<div class="form-group" fxLayout fxLayout.xs="column" fxLayoutAlign="space-between center">
		<label for="confirmPassword" class="control-label" fxFlex="45">
			{{'Repeat new password' | translate}} *
		</label>
		<div class="input-container" fxFlex="55" fxLayout="column">
			<input
				formControlName="confirmPassword"
				type="password"
				class="form-control"
				id="confirmPassword" name="confirmPassword">
			<div fxLayout="column" class="feedback-wrapper"
					*ngIf="getChangePasswordForm().controls['confirmPassword'].errors && (getChangePasswordForm().controls['confirmPassword'].dirty || getChangePasswordForm().controls['confirmPassword'].touched)">
				<small [hidden]="!getChangePasswordForm().controls['confirmPassword'].errors.required" class="feedback">
					{{'Required' | translate}}.
				</small>
			</div>
      <div fxLayout="column" class="feedback-wrapper"
					*ngIf="getChangePasswordForm().errors && (getChangePasswordForm().controls['confirmPassword'].dirty || getChangePasswordForm().controls['confirmPassword'].touched) && getChangePasswordForm().errors.passwordsDoNotMatch">
        <small class="feedback">
          {{'Passwords do not match' | translate}}.
        </small>
      </div>
		</div>
  </div>

  <div class="" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around center">
    <button id="changePassword" type="submit" class="btn btn-primary" [disabled]="getChangePasswordForm().invalid">
      {{'Change password' | translate}}
    </button>
  </div>

</form>

<hr>
